import axios from 'axios';
import { hostConfig } from '../config'; // Adjust path as needed

// Create and export the secure client with an optional API base
const createSecureClient = (apiBase = null) => {
  const client = axios.create({
    baseURL: apiBase || hostConfig.API_BASE,
    headers: {
      'Content-Type': 'application/json',
      'X-API-Key': hostConfig.API_KEY || 'dev-api-key-123'
    },
    withCredentials: true // Enables sending cookies in cross-domain requests
  });
  
  // Add request interceptor to ensure token is included in every request
  client.interceptors.request.use(
    config => {
      // Get the token based on user role
      const userRole = localStorage.getItem('userRole');
      const tokenKey = userRole === 'therapist' ? 'therapistToken' : 'patientToken';
      const token = localStorage.getItem(tokenKey);
      
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
        console.log(`Adding token to request: ${config.method.toUpperCase()} ${config.url}`);
      } else {
        console.log(`No token found for request: ${config.method.toUpperCase()} ${config.url}`);
      }
      
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );
  
  // Add response interceptor for token refresh or error handling
  client.interceptors.response.use(
    response => {
      return response;
    },
    error => {
      // Handle 401 errors (unauthorized)
      if (error.response && error.response.status === 401) {
        console.error('Authentication error - redirecting to login');
        
        // Clear tokens and redirect to login
        const userRole = localStorage.getItem('userRole');
        localStorage.removeItem(userRole === 'therapist' ? 'therapistToken' : 'patientToken');
        localStorage.removeItem('isLoggedIn');
        
        // Don't redirect automatically in this utility, let components handle it
      }
      
      return Promise.reject(error);
    }
  );
  
  return client;
};

// Create default instances
// Create default instances with correct API base URLs
export const secureClient = createSecureClient(hostConfig.API_BASE || 'https://care.ascnau.com/api');
export const therapistClient = createSecureClient(hostConfig.THERAPIST_API_BASE || 'https://care.ascnau.com/api/therapist');
export const patientClient = createSecureClient(hostConfig.API_BASE || 'https://care.ascnau.com/api/patient');

// Export the creation function too in case it's needed elsewhere
export { createSecureClient };